import React from "react";

// ─── Active-filter chip (renders below the filter row) ──────────────────────────
// Each chip shows the active filter's label (and value when set) with a remove
// button. Purely presentational — `onRemove` is wired by the page.
function FilterChip({ label, value, onRemove }) {
  return (
    <span className="inline-flex items-center gap-1 rounded-full bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300 text-xs px-2.5 py-1">
      {label}{value ? `: ${value}` : ""}
      <button type="button" onClick={onRemove} className="ml-0.5 text-gray-400 hover:text-gray-700 dark:text-gray-500 dark:hover:text-gray-200">×</button>
    </span>
  );
}

export default FilterChip;
